<div class="code" role="group" [attr.aria-required]="required()">
  @for (index of indexes; track index) {
    <input
      #codeInput
      class="code__input"
      type="text"
      autocomplete="one-time-code"
      maxlength="6"
      pattern="[A-Za-z0-9]*"
      [disabled]="disabled"
      [value]="getCharacter(index)"
      [attr.aria-label]="'Character ' + (index + 1) + ' of ' + length()"
      (input)="handleInput($event, index)"
      (paste)="handlePaste($event, index)"
      (keydown)="handleKeydown($event, index)"
      (blur)="markAsTouched()"
    />
  }
</div>
